<div>
  <div class="w-full flex align-items-center flex-wrap mb-4"
    [ngClass]="{'justify-content-between': modalMode, 'justify-content-end': !modalMode}">
    <div *ngIf="modalMode">
      <span>Selecciona los documentos que desees asignar a la orden.</span>
    </div>
    <div class="container-toggle" *ngIf="modalMode">
      <p-inputSwitch
        [(ngModel)]="filterSuggested"
        (onChange)="onSearch()"
        styleClass="switch-large"
        >
      </p-inputSwitch>
      <h4 class="label-toggle">
        Sugeridos
      </h4>
    </div>
    <div class="flex gap-2 justify-content-end w-6">
      <span class="p-input-icon-left flex-1">
        <i class="pi pi-search custom-input-icon"></i>
        <input [(ngModel)]="searchTerm" type="text" pInputText
          placeholder="Buscar por asunto, nombre o correo emisor"
          class="p-inputtext-sm custom-input bg-form w-full"
          (keydown.enter)="onSearch()" />
      </span>
      <p-button
        (onClick)="onSearch()"
        label="Buscar"
        class="custom-text-button">
      </p-button>
    </div>
  </div>

  <div class="flex justify-content-between mb-4 info-container" *ngIf="importOrderInformation">
    <div>
      <p class="p-info">Ship: {{importOrderInformation.delivery?.ship ? importOrderInformation.delivery?.ship : ('AdminOrderDetailManagement.Order.PendingLabel' | translate) }}</p>
    </div>
    <div>
      <p class="p-info">Container: {{ importOrderInformation.delivery?.containerNumber ? importOrderInformation.delivery?.containerNumber : ('AdminOrderDetailManagement.Order.PendingLabel' | translate) }}</p>
    </div>
    <div>
      <p class="p-info">Booking: {{ importOrderInformation.delivery?.booking ? importOrderInformation.delivery?.booking : ('AdminOrderDetailManagement.Order.PendingLabel' | translate) }}</p>
    </div>
    <div>
      <p class="p-info">DUS: {{ importOrderInformation.delivery?.dus ? importOrderInformation.delivery?.dus : ('AdminOrderDetailManagement.Order.PendingLabel' | translate) }}</p>
    </div>
    <div>
      <p class="p-info">Instructions: {{importOrderInformation.delivery?.deliveryInstructions ? importOrderInformation.delivery?.deliveryInstructions : ('AdminOrderDetailManagement.Order.PendingLabel' | translate) }}</p>
    </div>
  </div>

  <div class="table-container">
    <p-table
      #dt
      [value]="filteredDocuments"
      dataKey="id"
      [paginator]="false"
      [loading]="isLoading"
      [(selection)]="selectedDocuments"
      class="downloaded-documents-table bg-header"
    >
      <ng-template pTemplate="header">
        <tr>
          <th *ngIf="modalMode" id="id" style="width: 4rem">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th id="document" style="width: 16rem; max-width: 16rem;">
            <div>
              <span>{{ 'AdminDownloadedDocuments.Table.DocumentColumn' | translate }}</span>
            </div>
          </th>
          <th *ngIf="modalMode" id="documentType" style="width: 12rem">
            <div>
              <span>{{ 'AdminDownloadedDocuments.Table.DocumentTypeColumn' | translate }}</span>
            </div>
          </th>
          <th id="subject" style="width: 12rem">
            <div>
              <span class="pr-1">{{ 'AdminDownloadedDocuments.Table.SubjectColumn' | translate }}</span>

              <!-- Filtro por Asunto -->
              <p-columnFilter
                field="subject" display="menu" matchMode="contains"
                [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                <ng-template pTemplate="header">
                  <div class="px-3 pt-1 pb-0">
                    <span class="filter-title">{{ 'AdminDownloadedDocuments.Table.SubjectColumn' | translate }}</span>
                  </div>
                </ng-template>
                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                  <p-dropdown
                    [ngModel]="value"
                    [options]="subjectFilter"
                    (onChange)="filter($event.value)"
                    optionLabel="label"
                    optionValue="value"
                    [filter]="true"
                    filterBy="label"
                    [autoDisplayFirst]="false"
                    class="custom-dropdown"
                  />
                </ng-template>
              </p-columnFilter>
            </div>
          </th>
          <th id="fromName" style="width: 10rem">
            <div>
              <span class="pr-1">{{ 'AdminDownloadedDocuments.Table.NameColumn' | translate }}</span>

              <!-- Filtro por Nombre emisor -->
              <p-columnFilter
                field="fromName" display="menu" matchMode="contains"
                [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                <ng-template pTemplate="header">
                  <div class="px-3 pt-1 pb-0">
                    <span class="filter-title">{{ 'AdminDownloadedDocuments.Table.NameColumn' | translate }}</span>
                  </div>
                </ng-template>
                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                  <p-dropdown
                    [ngModel]="value"
                    [options]="issuerNameFilter"
                    (onChange)="filter($event.value)"
                    optionLabel="label"
                    optionValue="value"
                    [filter]="true"
                    filterBy="label"
                    [autoDisplayFirst]="false"
                    class="custom-dropdown"
                  />
                </ng-template>
              </p-columnFilter>
            </div>
          </th>
          <th id="email" style="width: 10rem">
            <div>
              <span class="pr-1">{{ 'AdminDownloadedDocuments.Table.EmailColumn' | translate }}</span>

              <!-- Filtro por Correo emisor -->
              <p-columnFilter
                field="email" display="menu" matchMode="contains"
                [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                <ng-template pTemplate="header">
                  <div class="px-3 pt-1 pb-0">
                    <span class="filter-title">{{ 'AdminDownloadedDocuments.Table.EmailColumn' | translate }}</span>
                  </div>
                </ng-template>
                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                  <p-dropdown
                    [ngModel]="value"
                    [options]="issuerEmailFilter"
                    (onChange)="filter($event.value)"
                    optionLabel="label"
                    optionValue="value"
                    [filter]="true"
                    filterBy="label"
                    [autoDisplayFirst]="false"
                    class="custom-dropdown"
                  />
                </ng-template>
              </p-columnFilter>
            </div>
          </th>
          <th id="matchDate">
            <div>
              <span class="pr-1">{{ 'AdminDownloadedDocuments.Table.MatchDateColumn' | translate }}</span>

              <!-- Filtro por Fecha de descarga -->
              <p-columnFilter
                type="date" field="matchDate" display="menu" matchMode="filter-date"
                [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"/>
            </div>
          </th>
          <th id="profileName">
            <div>
              <span class="pr-1">{{ 'AdminDownloadedDocuments.Table.ProfileColumn' | translate }}</span>

              <!-- Filtro por Perfil -->
              <p-columnFilter
                field="profileName" display="menu" matchMode="contains"
                [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                <ng-template pTemplate="header">
                  <div class="px-3 pt-1 pb-0">
                    <span class="filter-title">{{ 'AdminDownloadedDocuments.Table.ProfileColumn' | translate }}</span>
                  </div>
                </ng-template>
                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                  <p-dropdown
                    [ngModel]="value"
                    [options]="profileFilter"
                    (onChange)="filter($event.value)"
                    optionLabel="label"
                    optionValue="value"
                    [filter]="true"
                    filterBy="label"
                    [autoDisplayFirst]="false"
                    class="custom-dropdown"
                  />
                </ng-template>
              </p-columnFilter>
            </div>
          </th>
          <th id="status">
            <div class="cell-style flex-row">
              <span class="pr-1">{{ 'AdminDownloadedDocuments.Table.StatusColumn' | translate }}</span>

              <!-- Filtro por Estado -->
              <p-columnFilter
                field="assigned" display="menu" matchMode="contains"
                [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                <ng-template pTemplate="header">
                  <div class="px-3 pt-1 pb-0">
                    <span class="filter-title">{{ 'AdminDownloadedDocuments.Table.StatusColumn' | translate }}</span>
                  </div>
                </ng-template>
                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                  <p-dropdown
                    [ngModel]="value"
                    [options]="statusFilter"
                    (onChange)="filter($event.value)"
                    optionLabel="label"
                    optionValue="value"
                    [filter]="true"
                    filterBy="label"
                    [autoDisplayFirst]="false"
                    class="custom-dropdown"
                  />
                </ng-template>
              </p-columnFilter>
            </div>
          </th>
          <th *ngIf="!modalMode" id="action">
            <div class="cell-style">
              {{ 'AdminDownloadedDocuments.Table.ActionsColumn' | translate }}
            </div>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-document>
        <tr>
          <td *ngIf="modalMode">
            <p-tableCheckbox [value]="document"></p-tableCheckbox>
          </td>
          <td
            style="cursor: pointer; width: 16rem; max-width: 16rem;"
            (click)="onDownloadDocument(document.guid)"
            [pTooltip]="document.name  ?? 'No disponible' "
            tooltipPosition="bottom"
          >
            <div class="flex justify-content-start align-items-center">
              <span class="pi pi-file mr-1 document-text"></span>
              <span class="document-text truncate">{{ document.name ?? "No disponible" }}</span>
            </div>
          </td>
          <td *ngIf="modalMode">
            <p-dropdown
              [options]="operationDocumentTypes"
              optionLabel="name"
              optionValue="id"
              [ngModel]="getSelectedDocumentType(document.id)"
              (ngModelChange)="setSelectedDocumentType(document.id, $event)"
              [placeholder]="'AdminDownloadedDocuments.Table.DocumentTypePlaceholder' | translate"
              class="custom-dropdown"
              appendTo="body"
              [style]="{'width': '180px'}">
            </p-dropdown>
          </td>
          <td style="width: 12rem">
            <span>{{ document.subject }}</span>
          </td>
          <td style="width: 10rem">
            <span>{{ document.fromName }}</span>
          </td>
          <td style="width: 10rem">
            <span>{{ document.email }}</span>
          </td>
          <td>
            <span>{{ document.created | date: 'dd-MM-yyyy HH:mm' }}</span>
          </td>
          <td>
            <span>{{ document.profileName }}</span>
          </td>
          <td>
            <div class="cell-style">
              <span [ngClass]="{'assigned': document.assigned, 'unassigned': !document.assigned}" class="status-text">
                {{ (document.assigned ?
                  'AdminDownloadedDocuments.Table.AssignedText' :
                  'AdminDownloadedDocuments.Table.UnassignedText') | translate }}
              </span>
            </div>
          </td>
          <td *ngIf="!modalMode">
            <div class="cell-style gap-2">
              <p-button
                [pTooltip]="'AdminDownloadedDocuments.Table.DeleteText' | translate"
                tooltipPosition="bottom"
                icon="pi pi-trash"
                class="custom-button-icon red-btn"
                (onClick)="onDelete(document.guid)"/>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <p-paginator
      [first]="(currentPage - 1) * pageSize"
      [rows]="pageSize"
      [totalRecords]="totalRecords"
      [rowsPerPageOptions]="[10, 25, 50]"
      (onPageChange)="onPageChange($event)"
      [showCurrentPageReport]="true"
      class="document-paginator"/>
  </div>

  <p-confirmDialog
    acceptLabel="Confirmar"
    rejectLabel="Cancelar"
    rejectButtonStyleClass="p-button-outlined" [style]="{width: '50vw'}">
  </p-confirmDialog>
</div>
